const {
    first, size, values, pickBy, isUndefined,
} = require('lodash');

class DigitalPayFormValidator {
    constructor(settings) {
        this.settings = settings;
    }

    getAddNewCreditCardValidationError(response, selectedField = '') {
        const errors = {};
        errors.card = this.addCreditCardNumberValidationError(response, selectedField);
        errors.month = this.addCreditCardMonthValidationError(response, selectedField);
        errors.year = this.addCreditCardYearValidationError(response, selectedField);
        errors.cvv = this.addCreditCardCvvValidationError(response, selectedField);

        return this.condenseCreditCardValidationErrors(errors);
    }

    getUpdateSavedCreditCardError(response, selectedField = '') {
        const errors = {};
        errors.month = this.addCreditCardMonthValidationError(response, selectedField);
        errors.year = this.addCreditCardYearValidationError(response, selectedField);
        errors.cvv = this.addCreditCardCvvValidationError(response, selectedField);

        return this.condenseCreditCardValidationErrors(errors);
    }

    getGiftCardValidationError(response, selectedField = '') {
        const errors = {};

        errors.card = this.addGiftCardNumberValidationError(response, selectedField);
        errors.pin = this.addGiftCardPinValidationError(response, selectedField);

        return this.condenseGiftCardValidationErrors(errors);
    }

    addCreditCardNumberValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayCreditCardFields.cardNumber) {
            if (!this.isFieldValid(response.cardValid)) {
                return this.settings.digitalPayError.creditCardInvalidCardNumberMessage;
            }

            if (this.isFieldValid(response.cardValid) && !this.isFieldValid(response.cardAccepted)) {
                return this.settings.digitalPayError.creditCardNotSupportedMessage;
            }
        }
        return undefined;
    }

    addCreditCardMonthValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayCreditCardFields.month && !this.isFieldValid(response.expiryMonthValid)) {
            return this.settings.digitalPayError.creditCardInvalidMonthMessage;
        }
        return undefined;
    }

    addCreditCardYearValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayCreditCardFields.year && !this.isFieldValid(response.expiryYearValid)) {
            return this.settings.digitalPayError.creditCardInvalidYearMessage;
        }
        return undefined;
    }

    addCreditCardCvvValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayCreditCardFields.cvv && !this.isFieldValid(response.cvvValid)) {
            return this.settings.digitalPayError.creditCardInvalidCvvMessage;
        }
        return undefined;
    }

    addGiftCardNumberValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayGiftCardFields.cardNumber && !this.isFieldValid(response.cardValid)) {
            return this.settings.digitalPayError.giftCardInvalidCardNumberMessage;
        }
        return undefined;
    }

    addGiftCardPinValidationError(response, selectedField) {
        if (selectedField !== this.settings.digitalPayGiftCardFields.pin && !this.isFieldValid(response.pinValid)) {
            return this.settings.digitalPayError.giftCardInvalidPinMessage;
        }
        return undefined;
    }

    condenseCreditCardValidationErrors(errors) {
        errors = pickBy(errors, property => !isUndefined(property));

        if (size(errors) === 2 && errors.month && errors.year) {
            return this.settings.digitalPayError.creditCardInvalidExpiryDetailsMessage;
        } else if (size(errors) > 1) {
            return this.settings.digitalPayError.creditCardMultipleValidationErrorsMessage;
        }

        return first(values(errors));
    }

    condenseGiftCardValidationErrors(errors) {
        errors = pickBy(errors, property => !isUndefined(property));

        if (size(errors) > 1) {
            return this.settings.digitalPayError.giftCardIncorrectDetailsMessage;
        }
        return first(values(errors));
    }

    /**
     * Determines if the field is valid or not
     * For the purposes of showing validation errors, an empty field (null) is valid. Empty field checking is done elsewhere.
     * @param {object} field
     */
    isFieldValid(field) {
        return field === null || field;
    }
}

module.exports = DigitalPayFormValidator;



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-form-validator.service.js